import { PaymentSource } from '../lims-types';

export interface PaymentSourceDefinition {
  code: PaymentSource;
  /** Raw i18n key (no namespace). Resolve with t(i18nKey, { ns: 'lims' }) at render time. */
  i18nKey: string;
}

export const PAYMENT_SOURCE_REGISTRY: Record<
  PaymentSource,
  PaymentSourceDefinition
> = {
  [PaymentSource.ELKE]: {
    code: PaymentSource.ELKE,
    i18nKey: 'payment.sources.elke',
  },
  [PaymentSource.EPI]: {
    code: PaymentSource.EPI,
    i18nKey: 'payment.sources.epi',
  },
  [PaymentSource.HOSPITAL]: {
    code: PaymentSource.HOSPITAL,
    i18nKey: 'payment.sources.hospital',
  },
  [PaymentSource.PRESCRIPTION]: {
    code: PaymentSource.PRESCRIPTION,
    i18nKey: 'payment.sources.prescription',
  },
  [PaymentSource.OTHER]: {
    code: PaymentSource.OTHER,
    i18nKey: 'payment.sources.other',
  },
} as const;

export const PAYMENT_SOURCE_I18N_KEYS: Record<PaymentSource, string> =
  Object.fromEntries(
    Object.values(PAYMENT_SOURCE_REGISTRY).map((d) => [d.code, d.i18nKey])
  ) as Record<PaymentSource, string>;

export const ALL_PAYMENT_SOURCES: PaymentSource[] = Object.values(
  PAYMENT_SOURCE_REGISTRY
).map((d) => d.code);

export const DEFAULT_CURRENCY = 'EUR' as const;

export const DEFAULT_PAYMENT_SOURCE = PaymentSource.ELKE;

export const resolvePaymentSource = (
  code: string | undefined
): PaymentSource | undefined => {
  if (!code) {
    return undefined;
  }
  return Object.values(PAYMENT_SOURCE_REGISTRY).find(
    (d) => d.code === (code as PaymentSource)
  )?.code;
}
